import { render } from "./wfm-pagination.vue?vue&type=template&id=346c3966&scoped=true"
import script from "./wfm-pagination.vue?vue&type=script&lang=js"
export * from "./wfm-pagination.vue?vue&type=script&lang=js"

import "./wfm-pagination.vue?vue&type=style&index=0&id=346c3966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346c3966"]])

export default __exports__